export default __webpack_public_path__ + "static/media/slide1.90e296f1.png";